import React from 'react';
import './ProductDisplay.css';

const ProductDisplay = (props) => {
    const {product} = props;
    return (
        <div className='productDisplay'>
            <div className='productDisplay-img-list'>
                {product.images?.map((img, index) => (
                    <img key={index} src={img} alt={`product-img-${index}`}/>
                ))}
            </div>
            <div className='productDisplay-right'>
                <h1>{product.name}</h1>
                <div className="productDisplay-right-price-old">{product.old_price}</div>
                <div className="productDisplay-right-price-new">{product.new_price}</div>
            </div>
            <div className='productDisplay-right-description'>{product.description}</div>
        </div>
    )
}

export default ProductDisplay;

//1.58.04